import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { PermissionContext, RolePermissions } from "appContext";
import { pages } from "views/pages/manage/common/constant";

import { getScreenCards } from "../../../finOps/IssueStock/search/SearchCard";
import { ReactComponent as RepeatIcon } from "../../../../../../assets/img/svg/fi_repeat.svg";
import { ReactComponent as DocumentIcon } from "../../../../../../assets/img/svg/Document.svg";

const ModuleCards = () => {
  const history = useHistory();

  const EPMRPermission = RolePermissions(
    useContext(PermissionContext),
    pages["epmrCancellation"]["id"]
  );

  const paymodeApprovalPermission = RolePermissions(
    useContext(PermissionContext),
    pages["paymodeApproval"]["id"]
  );

  const transferApprovalPermission = RolePermissions(
    useContext(PermissionContext),
    pages["studentTransferApproval"]["id"]
  );

  const refundApprovalPermission = RolePermissions(
    useContext(PermissionContext),
    pages["studentRefundApproval"]["id"]
  );

  const cashManagementApprovalPermission = RolePermissions(
    useContext(PermissionContext),
    pages["cashManagementApproval"]["id"]
  );

  const chequeManagementApprovalPermission = RolePermissions(
    useContext(PermissionContext),
    pages["chequeManagementApproval"]["id"]
  );

  const cards = [
    {
      heading: "Concession approvals",
      subHeading: "Review student concessions applied",
      icon: (
        <span className="iconWrapper">
          <RepeatIcon />
        </span>
      ),
      action: () => {
        history.push("/admin/concessionApproval/pending");
      },
    },
    paymodeApprovalPermission && {
      heading: "Paymode approval",
      subHeading: "Approve payment method change requests",
      icon: (
        <span className="iconWrapper">
          <RepeatIcon />
        </span>
      ),
      action: () => {
        history.push("/admin/paymodeApproval");
      },
    },

    // {
    //   heading: "Cash deposit approvals",
    //   subHeading: "View and review all cash transactions",
    //   icon: <DocumentIcon />,
    //   action: () => { },
    // },

    ...(EPMRPermission.length
      ? [
        {
          heading: "EPMR cancellation requests",
          subHeading: "View and review all cash transactions",
          icon: <DocumentIcon />,
          action: () => {
            history.push("/admin/epmrCancellation");
          },
        },
      ]
      : []),

    transferApprovalPermission && {
      heading: "Student transfer approvals",
      subHeading: "View and review all transfers",
      icon: (
        <span className="iconWrapper">
          <RepeatIcon />
        </span>
      ),
      action: () => {
        history.push("/admin/transferApproval");
      },
    },
    refundApprovalPermission && {
      heading: "Student refund approvals",
      subHeading: "View and review all refunds",
      icon: (
        <span className="iconWrapper">
          <RepeatIcon />
        </span>
      ),
      action: () => {
        history.push("/admin/studentRefundApproval");
      },
    },
    cashManagementApprovalPermission && {
      heading: "Cash management approvals",
      subHeading: "Review request of cash collected at source",
      icon: (
        <span className="iconWrapper">
          <RepeatIcon />
        </span>
      ),
      action: () => {
        history.push("/admin/paymentManagementApproval/cash");
      },
    },
    chequeManagementApprovalPermission && {
      heading: "Cheque extension approvals",
      subHeading: "Review request of cheque collected at source",
      icon: (
        <span className="iconWrapper">
          <RepeatIcon />
        </span>
      ),
      action: () => {
        history.push("/admin/paymentManagementApproval/cheque");
      },
    },
  ];
  return (
    <>
      <div className={`screen-cards-container`}>
        {getScreenCards(cards?.filter((card) => card))}
      </div>
    </>
  );
};

export default ModuleCards;
